<template>
  <div class="header-wrapper">
    <div class="header-box">
      <div class="left">
        <div class="logo" title="神奇管家"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderPage",
  props: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.header-box {
  width: 1280px;
  margin: 0 auto;
  // padding: 0 40px;
  height: 60px;
  line-height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  .left {
    .logo {
      width:120px;
      height: 40px;
      background: url("../assets/images/v3_nlogo.png") no-repeat center;
      background-size: 100% auto;
    }
  }

}
</style>
